import {useState} from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import WarningIcon from '@mui/icons-material/Warning';

import BooleanField from '../common/BooleanField';
import CustomSelect from '../common/CustomSelect';
import {useGetCasesQuery, useUpdateCaseMutation} from '../../redux/services/caseApi';
import {getCaseStatuses} from '../../helpers/selectOptions';

const handleFieldChange = ({id, put, handleUpdateInternally, onChange}) => fieldName => async e => {
  const value = e?.target?.value;
  if (handleUpdateInternally) {
    const body = {status: value};
    const response = await put({id, body});
  }
  if (onChange) onChange(e, {status: value});
};

const CompleteCaseForm = props => {
  const {caseId, onChange, handleUpdateInternally} = props;
  const [isEditingStatus, setIsEditingStatus] = useState(false);
  const [put] = useUpdateCaseMutation();
  const caseQuery = useGetCasesQuery({id: caseId}, {skip: !caseId});
  const caseData = caseQuery.data?.data?.[0] || null;
  const onFieldChange = handleFieldChange({
    id: caseId, 
    put,
    handleUpdateInternally,
    onChange
  });
  if (!caseId) return null;
  return (
    <Stack gap={1}>
      <Stack direction='row' spacing={2} paddingTop={0.5}>
        <BooleanField 
          label={props?.label || 'This is the last session in this plan of care.'}
          onChange={() => setIsEditingStatus(!isEditingStatus)}
          value={isEditingStatus}
        />
        {isEditingStatus && caseData ? 
          <Box style={{width: '200px'}} paddingTop={0.5}>
            <CustomSelect
              fullWidth
              size='small'
              defaultValue={caseData?.status}
              options={getCaseStatuses().filter(option => option.value !== 'ACTIVE')}
              onChange={onFieldChange('status')}
            /> 
          </Box>
          : null
        }
      </Stack>
      {isEditingStatus && <Stack direction='row' spacing={1} alignItems='center'>
        <WarningIcon color='warning'/>
        <Typography variant='body1' color='text.light'>
          Ending this plan of care will close the case for all providers involved. 
          If other providers are continuing to treat this patient, leave this case active.
        </Typography>
      </Stack>
      }
    </Stack>
  );
};

CompleteCaseForm.defaultProps = {
  handleUpdateInternally: false,
};

CompleteCaseForm.propTypes = {
  caseId: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  handleUpdateInternally: PropTypes.bool,
};

export default CompleteCaseForm;